import { axiosInstance } from "../App";

import { GetItemsProps, mobilePhoneToString } from "medere-ui-framework";
import { DigitalRpForHistoryDTO, Medicine, PatientRecordDTO, PrescriptionRequestResponseDTO, Professional, RecipeDTO, RecipeMessageDTO, RequestedPrescriptions, SitePropertiesDTO, UserAllowedToPrescript } from "../interface/interface";

export async function setDigitalRpAsUsed(digitalrp:string,pharmacy:string){
    let ip="";
    let coordenadas:any={}
    const onLocationAllowed = ({coords, timestamp}:any) => {
       coordenadas=coords;
      }
    
      const onLocationNotAllowed = () => {
      }
    
    navigator.geolocation?.getCurrentPosition(onLocationAllowed, onLocationNotAllowed)
    let ipResponse= await getClientIp();
    if(ipResponse.status==200)
        ip=ipResponse.data;

    let rpMarkedResponse= await setDigitalRpAsMarked(ip,coordenadas.latitude ? coordenadas.latitude : null,coordenadas.longitude? coordenadas.longitude : null,digitalrp,pharmacy)
    
    return rpMarkedResponse;
}

export async function setDigitalRpAsMarked(ip:any,latitude:any,longitude:any,digitalrp:any,pharmacy:any){
    let response=  await axiosInstance.post('/api/secured/digitalrpservicecontroller/setDigitalRPAsUsed',
    {
        ip:ip,
        latitude:latitude,
        longitude:longitude,
        browser:navigator.userAgent,
        digitalRpUUID:digitalrp,
        identification:pharmacy
    }).then(res=>res.data).catch(err=>err)
    return response;
}

export async function getClientIp(){
    let response =await  axiosInstance.get('/api/secured/digitalrpservicecontroller/getIp').then(res=>res).catch(err=>err)
    return response;
}

export function getDigitalRPMarkRecord(rpUuid:string){
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/getDigitalRPMarkRecord',{
        params:{
            rpUUID:rpUuid
        }
    }).then(res=>res).catch(err=>err)
}

export function getPdfDigitalRpByUUID(digitalRp:any){
    
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/findDigitalRPPDFByUUID',
    {  responseType: 'blob',
        params:{
            rpUUID:digitalRp,
        }

    })
    .then((response) => {
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `descargar reporte_${digitalRp}.pdf`;

    document.body.appendChild(a);
    a.click();

    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);

    return true;
  })
  .catch((error) => {
    console.error('Error al descargar el PDF:', error);
    return false;
  });
}

export function getDataDecript(professional:any,patient:any,uuid:any){
    return axiosInstance.post('/api/secured/digitalrpservicecontroller/getDataDecript',{
        professional:professional,
        patient:patient,
        uuid:uuid
    }
    ).then(res=>res.data)
}

export function findDigitalRPPDFByCodeBar(codeBar:string) {
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/findDigitalRPPDFByCodeBar', {
        params: {
            codeBar: codeBar
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        return null;
    });
}

export function savePatient(patient: PatientRecordDTO, pageSize: number, offSet: number) {
    return axiosInstance.post(
        '/api/secured/digitalrpservicecontroller/savePatient',
        {
            ...patient,
        },
        {
            params: {
                pageSize,
                offSet
            }
        }
    ).then(response => {
        return response.data;
    })
    .catch(error => {
        console.error('Error al guardar los datos:', error);
        throw error;
    });
}

export async function getPatientsInfo(inputText: string, pageSize: number, offSet: number) {
    try {
        const response = await axiosInstance.get('/api/secured/digitalrpservicecontroller/getPatientsInfo', {
            params: {
                inputText,
                pageSize,
                offSet
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching patients info:', error);
        throw error;
    }
}

export function getAllHealthEntities({filterValue,offSet,pageSize,params}:GetItemsProps){
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/getAllHealthEntities',{
        params: {
            offSet: offSet,
            pageSize,
            inputText:filterValue??''
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getAllHealthEntityPlanByHealthEntityId({filterValue,offSet,pageSize,params}:GetItemsProps){
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/getAllHealthEntityPlanByHealthEntityId',{
        params: {
            offSet: offSet,
            pageSize,
            healthEntityId: params.healthEntityId,
            inputText:filterValue??'',
            professionalUserId:''
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function getMedicines({filterValue,offSet,pageSize,params}:GetItemsProps){
    return axiosInstance.get("/api/secured/digitalrpservicecontroller/getSubstancesAndMedicinalProducts", {
    params: {
        pageSize: pageSize ?? 10,
        firstRow: offSet ?? 0,
        inputText: filterValue ?? '',
        language: params.language,
        informationProvider: params?.InforProvider ?? 1,
        healthEntityId: params?.healthEntityId ?? -1,
    },
    }).then(response => {
        return response.data
    }).catch((error) => {
        console.log(error)
    });
}

export function getPresentations({filterValue,offSet,pageSize,params}:GetItemsProps){
    if(!params.issubstance){
        return axiosInstance.get('/api/secured/digitalrpservicecontroller/getMedicinalProductPresentationsByMedicinalProduct',
        {
            params: {
                pageSize: pageSize,
                firstRow: offSet,
                inputText: filterValue??'',
                language: params.language,
                informationProvider: params.informationProvider,
                medicinalProduct: params.id,
            }
        }).then(res => {return res.data})
    }else{
        return axiosInstance.get('/api/secured/digitalrpservicecontroller/getMedicinalProductPresentationsBySubstance',
        {
            params: {
                pageSize: pageSize,
                firstRow: offSet,
                language: params.language,
                informationProvider: params.informationProvider,
                substance: params.id,
                inputText: filterValue??'',

            }
        }).then(res => {return res.data})
    }
}

export function saveDigitalRp(data:RecipeDTO) {
    return axiosInstance.post('/api/secured/digitalrpservicecontroller/saveDigitalRp', data)
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        throw error;
    });
}

export function saveDigitalRpRequested(data:RecipeDTO) {
    return axiosInstance.post('/api/secured/digitalrpservicecontroller/saveDigitalRpRequested', data)
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        throw error;
    });
}

export function getPreviousMedications (patientid:number, informationprovider:number){
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/getLastPrescriptions', {
        params: {
            patientId: patientid,
            informationProvider: informationprovider
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        throw error;
    });
}

export function sendDigitalRpByMessageSender(recipeMessageDTO: RecipeMessageDTO) {
    return axiosInstance.post('/api/secured/digitalrpservicecontroller/sendDigitalRpByMessageSender', recipeMessageDTO)
    .then(response => {
        return response.data;
    })
    .catch(error => {
        if (error.response && error.response.status === 400) {
            console.error('Celular incorrecto:', error.response.data);
            throw error;
        } else {
            console.error('Error al enviar el mensaje:', error);
            throw error;
        }
    });

}

export function loadMedicalSpecialities() {
    return axiosInstance('/api/secured/digitalrpservicecontroller/loadMedicalSpecialities', {
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error('Error al cargar especialidades médicas:', error);
        throw error;
    });
}

export function updateProfessional(professionalDTO: Professional) {
    return axiosInstance.post('/api/secured/digitalrpservicecontroller/updateProfessional', professionalDTO)
        .then(response => {
            return response.status;
        })
        .catch(error => {
            console.error(error);
            throw error;
        });
}

export function hasSenderPermissionByTaskMessageTypeAndMessageType(messageType: number, taskMessageType: number): Promise<SitePropertiesDTO> {
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/hasSenderPermissionByTaskMessageTypeAndMessageType', {
        params: {
            messageType: messageType,
            taskMessageType: taskMessageType,
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        throw error;
    });
}

export function isProfessionalUser (): Promise<boolean> {
    return retry401(() => axiosInstance.get('/api/secured/digitalrpservicecontroller/isProfessional')
        .then(response => response.data));
}

export function getProfessionalData (): Promise<Professional> {
    return retry401(() =>
        axiosInstance.get('/api/secured/digitalrpservicecontroller/loadProfessionalByUserId')
            .then(res => res.data)
    );
}

export function getPatientData(patientId: number): Promise<PatientRecordDTO> {
    return retry401(() =>
        axiosInstance.get('/api/secured/digitalrpservicecontroller/loadPatientById', {
            params: { patientId }
        }).then(res => res.data)
    );
}

export async function extractPatientIdentifications(data) {
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/extractPatientIdentifications', {
        params: {
            data: data
        }
    }).then(res => {
        return res.data;
    }).catch(e => {
        return e;
    });
}

export function loadPatientByDocAndDocType (document: string, documentType: string) : Promise<PatientRecordDTO> {
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/loadPatientByDocAndDocType', {
        params: {
            document,
            documentType
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        throw error;
    });
}

export function isGenderNull (patientId:number) : Promise<boolean> {
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/isGenderNull', {
        params: {
            patientId: patientId
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        throw error;
    });
}

export function loadRequestedPrescriptions(professionalId: number, patientInput: string): Promise<RequestedPrescriptions[]> {
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/loadRequestedPrescriptionDTO', {
        params: {
            professionalId: professionalId,
            patient: patientInput
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        throw error;
    });
}

export function loadRpDetailsForRequestedPrescription(prescriptionRequest: number): Promise<Medicine[]> {
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/loadRpDetailsForRequestedPrescription', {
        params: {
            prescriptionRequest: prescriptionRequest
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        throw error;
    });
}

export function loadAdministrativesEnabledForPrescription({filterValue,offSet,pageSize,params}:GetItemsProps){
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/loadAdministrativesEnabledForPrescription',{
        params: {
            offSet: offSet,
            pageSize,
            inputText:filterValue??''
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function loadAdministrativeEnabledForPrescription() {
    return retry401(() =>
        axiosInstance.get('/api/secured/digitalrpservicecontroller/loadAdministrativeEnabledForPrescription')
            .then(res => res.data)
    );
}

export function loadProfessionalsPermissionsForRpGivenToUser({filterValue,offSet,pageSize}:GetItemsProps) {
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/loadProfessionalsPermissionsForRpGivenToUser', {
        params: {
            offSet: offSet,
            pageSize,
            inputText:filterValue??'',
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        throw error;
    });
}

export function updateUsersAllowedToPrescript(permissionToPrescriptDTOs:any): Promise<UserAllowedToPrescript[]> {
    return axiosInstance.post('/api/secured/digitalrpservicecontroller/updateUsersAllowedToPrescript', permissionToPrescriptDTOs)
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        throw error;
    });
}

export function loadAdministrativesAllowedByProfessional(professionalId: number) {
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/loadAdministrativesAllowedByProfessional', {
        params: {
            professional: professionalId
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        throw error;
    });
}

export function loadEnrollmentType({filterValue,offSet,pageSize,params}:GetItemsProps){
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/loadenrollmenttype',{
        params: {
            offSet: offSet,
            pageSize,
            inputText:filterValue??''
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function saveAdministrativeEntities(userAllowedToPrescriptDTO: UserAllowedToPrescript) {
    return axiosInstance.post('/api/secured/digitalrpservicecontroller/saveAdministrativeEntities', userAllowedToPrescriptDTO)
    .then(response => {
        return response.status
    })
    .catch(error => {
        console.error(error);
        throw error;
    });
}

export function loadDigitalRpHistory(professionalId: number, patientInput: string): Promise<DigitalRpForHistoryDTO[]> {
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/loadDigitalRpHistory', {
        params: {
            professional: professionalId,
            patient: patientInput
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        throw error;
    });
}

export function copyDigitalRpById(digitalRpId: number): Promise<RecipeDTO> {
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/copyDigitalRpById', {
        params: {
            digitalRp: digitalRpId
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        throw error;
    });
}

export function loadWebAppointmentsUrl(): Promise<string> {
    return retry401(() =>
        axiosInstance.get('/api/secured/digitalrpservicecontroller/getUrlWebAppointments')
            .then(res => res.data)
    );
}

export function rejectPrescriptionRequest(rejectionDTO: PrescriptionRequestResponseDTO) {
    return axiosInstance.post('/api/secured/digitalrpservicecontroller/rejectPrescriptionRequest', rejectionDTO)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            console.error('Error al rechazar la solicitud de prescripción:', error);
            throw error;
        });
}

export function loadRequestedPrescriptionsForAdministrative(): Promise<RequestedPrescriptions[]> {
    return retry401(() =>
        axiosInstance.get('/api/secured/digitalrpservicecontroller/loadRequestedPrescriptionForAdministrativeAllowedDTO')
            .then(res => res.data)
    );
}

export function loadDigitalRpHistoryForAdministratives(patientInput: string): Promise<DigitalRpForHistoryDTO[]> {
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/loadDigitalRpHistoryForAdministratives', {
        params: {
            patient: patientInput
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        throw error;
    });
}
export function loadProfessionalByMedereEntity (medereEntity:number) : Promise<Professional> {
    return axiosInstance.get('/api/secured/digitalrpservicecontroller/loadProfessionalByMedereEntity', {
        params: {
            medereEntityId: medereEntity,
        }
    })
    .then(response => {
        return response.data;
    })
    .catch(error => {
        console.error(error);
        throw error;
    });
}

export function loadDigitalRpFile(file: DigitalRpForHistoryDTO): Promise<DigitalRpForHistoryDTO> {
    return axiosInstance.post('/api/secured/digitalrpservicecontroller/loadDigitalRpFile',file).then(res=>res.data)
}

async function retry401<T>(fn: () => Promise<T>, retries = 2, delay = 500): Promise<T> {
    for (let i = 0; i <= retries; i++) {
        try {
            return await fn();
        } catch (error: any) {
            if (error?.response?.status === 401 && i < retries) {
                await new Promise(res => setTimeout(res, delay * (i + 1)));
            } else {
                throw error;
            }
        }
    }
    throw new Error('Retries exhausted');
}